module.exports = __webpack_public_path__ + "img/shenlan.62c4c199.png";